import Immutable from 'immutable'
import {stateStructure} from './_stateStructure.js'
import * as ACTION from '../constants/types/pushTypes';
import * as USER_ACTION from '../constants/types/userTypes'

const initialState = Immutable.fromJS( stateStructure.push );

export default function push( state = initialState, action ){

	let _state = state.toJS();

	switch (action.type) {
		
		// 获取推送服务器信息
		case ACTION.GET_PUSH_SERVICE_INFO:{
			_state.server_info =action.result.data;
			_state.push_status = true;
			return state.merge(_state);
		}

		// 开始推送
		case ACTION.START_PUSH:{
			_state.push_status = true;
			return state.merge(_state);
		}

		// 关闭推送
		case ACTION.END_PUSH:{
			_state.push_status = false;
			return state.merge(_state);
		}
		
		// 注销用户
		case USER_ACTION.LOGOUT:{
			//关闭推送
			_.forEach(window.PushStreamManager, function(pushservice){
				pushservice.disconnect();
			})
			window.PushStreamManager = [];
			return initialState;
		}

		default:
      		return state;
	}
}